/**
 * Platform fee configuration.
 * PLATFORM_CHARGE_RATE is the percentage the platform takes from the reward.
 * influencerReward = rewardAmount * (1 - PLATFORM_CHARGE_RATE)
 * platformFee = rewardAmount * PLATFORM_CHARGE_RATE
 */
export const PLATFORM_CHARGE_RATE = 0.20; // 20%
export const INFLUENCER_PAYOUT_RATE = 1 - PLATFORM_CHARGE_RATE; // 80%
